<template>
  <div class="main-container">
    <div class="ui middle aligned center aligned grid">
      <div class="login-container" style="max-width: 560px;">
        <div class="login-content">
          <h1>Accept invitation</h1>
          <p class="light" v-if="invitation">
            <span v-if="invitation.inviter_name">{{ invitation.inviter_name }} from </span>
            <strong>{{ invitation.company_name }}</strong> has invited you to use Smardie.
          </p>

          <app-form-error></app-form-error>

          <div v-if="loading" class="ui active centered inline loader"></div>

          <form v-else-if="invitation" class="ui form" @submit.prevent="accept">
            <h4 class="ui dividing header">Your profile</h4>
            <div class="two fields">
              <div class="field">
                <label>First Name*</label>
                <input type="text" v-model="form.first_name" required>
              </div>
              <div class="field">
                <label>Last Name*</label>
                <input type="text" v-model="form.last_name" required>
              </div>
            </div>
            <div class="field">
              <label>Email Address*</label>
              <input type="email" v-model="form.email" disabled>
            </div>
            <div class="field">
              <label>Mobile Number*</label>
              <input type="text" v-model="form.mobile" placeholder="Enter mobile number" required>
            </div>

            <template v-if="!invitation.has_existing_account">
              <h4 class="ui dividing header">Create a password</h4>
              <div class="field">
                <label>Password*</label>
                <input type="password" v-model="form.password" required>
              </div>
              <div class="field">
                <label>Confirm Password*</label>
                <input type="password" v-model="form.password_confirmation" required>
              </div>
            </template>

            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" v-model="form.terms_accepted" id="invite-terms">
                <label for="invite-terms">
                  By creating an account you agree to Smardie
                  <router-link to="/terms" target="_blank">Terms &amp; Conditions</router-link>
                  and
                  <router-link to="/privacy" target="_blank">Privacy Policy</router-link>.
                </label>
              </div>
            </div>

            <div class="field">
              <button type="submit" class="ui fluid primary button" :class="{ loading: submitting }" :disabled="submitting">
                Accept invitation
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'InviteAccept',
  data () {
    return {
      token: '',
      invitation: null,
      loading: true,
      submitting: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        password: '',
        password_confirmation: '',
        terms_accepted: false
      }
    }
  },
  mounted () {
    this.token = this.$route.params.token
    if (!this.token) {
      this.errorNotification('Invalid invitation link')
      this.$router.push('/login')
      return
    }
    axios.get(`/api/invitations/verify/${this.token}`).then((res) => {
      const inv = res.data && res.data.invitation
      if (!inv) throw new Error('Invalid invitation')
      this.invitation = inv
      this.form.first_name = inv.first_name || ''
      this.form.last_name = inv.last_name || ''
      this.form.email = inv.email || ''
    }).catch((err) => {
      const msg = (err.response && err.response.data && err.response.data.error) || 'Invitation not found'
      this.errorNotification(msg)
      this.$router.push('/login')
    }).finally(() => {
      this.loading = false
      this.$nextTick(() => { $(this.$el).find('.ui.checkbox').checkbox() })
    })
  },
  methods: {
    accept () {
      if (!this.form.first_name.trim() || !this.form.last_name.trim() || !this.form.mobile.trim()) {
        this.errorNotification('Please complete all required fields')
        return
      }
      if (!this.form.terms_accepted) {
        this.errorNotification('Please accept the terms and conditions')
        return
      }
      if (!this.invitation.has_existing_account) {
        if (!this.form.password || this.form.password.length < 6) {
          this.errorNotification('Password must be at least 6 characters')
          return
        }
        if (this.form.password !== this.form.password_confirmation) {
          this.errorNotification('Passwords do not match')
          return
        }
      }

      this.submitting = true
      axios.post('/api/invitations/accept', {
        token: this.token,
        first_name: this.form.first_name.trim(),
        last_name: this.form.last_name.trim(),
        mobile: this.form.mobile.trim(),
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
        terms_accepted: true
      }).then((res) => {
        if (res.data.requires_login) {
          this.successNotification('Invitation accepted. Please log in to continue.')
          this.$router.push('/login')
          return
        }
        if (res.data.token) {
          localStorage.setItem('token', res.data.token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token
          this.$store.commit('user/setLoggedIn')
          return axios.get('/api/auth/user').then((profileRes) => {
            if (profileRes.data && profileRes.data.user) {
              this.$store.commit('user/setUserProfile', profileRes.data.user)
            }
            this.successNotification('Welcome to Smardie!')
            this.$router.push('/')
          })
        }
        this.successNotification('Welcome to Smardie!')
        this.$router.push('/')
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Failed to accept invitation'
        this.errorNotification(msg)
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>
